import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useReactiveVar } from "@apollo/client";
import LogoDefault from "@me-team/common/src/images/logo-add.png";
import { CompanyAccess, CompanyProxy } from "../../../main/graphql/types";
import { currentCompanyIdVar } from "../../../main/globalVar/state";
import { WithRoleAccess } from "@services/ui-components";

type SidebarHeaderProps = {
    company: CompanyProxy;
    isMobile?: boolean;
    handleCloseNavbar?: () => void;
};
const SidebarSubheader: React.FC<SidebarHeaderProps> = ({ company, isMobile = false, handleCloseNavbar }) => {
    const { branchId } = useParams();
    const currentCompanyId = useReactiveVar(currentCompanyIdVar);
    const basePath = process.env.REACT_APP_POS_URL;
    const navigate = useNavigate();
    const companyNameClassName = `text-dark text-break text-decoration-none fw-bold fs-20 ms-2 me-3 mb-0 ${isMobile ? "text-truncate" : ""}`;

    return (
        <>
            <div className={`d-flex align-items-center ${isMobile ? "justify-content-center text-truncate" : ""}`}>
                <div className="d-flex justify-content-start align-items-center ms-2">
                    <img
                        src={company?.image ? `${basePath}/${company.image}` : LogoDefault}
                        alt={company?.name}
                        style={{ width: "35px", height: "35px" }}
                        loading="lazy"
                    />
                </div>
                <WithRoleAccess
                    permission={CompanyAccess.BranchView}
                    fallback={
                        <span title={company?.name} className={companyNameClassName}>
                            {company?.name}
                        </span>
                    }
                >
                    <Link
                        to={`branches/${branchId}`}
                        title={company?.name}
                        className={companyNameClassName}
                        onClick={handleCloseNavbar}
                    >
                        {company?.name}
                    </Link>
                </WithRoleAccess>
            </div>
            <WithRoleAccess permission={CompanyAccess.CompanyInfoView}>
                <button
                    className="edit-button border-0 px-0"
                    onClick={() => navigate(`company/${currentCompanyId}/edit/${branchId}`)}
                >
                    <WithRoleAccess
                        permission={CompanyAccess.CompanyInfoEdit}
                        fallback={<i className="bi bi-eye text-primary fs-normal"></i>}
                    >
                        <i className="bi bi-pencil text-primary fs-normal"></i>
                    </WithRoleAccess>
                </button>
            </WithRoleAccess>
        </>
    );
};

export default SidebarSubheader;
